<template>
  <div class="vx-col md:w-3/5 w-full mb-base m-auto">
    <vx-card title="Profile">
      <form data-vv-scope="profile" @submit.prevent>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="Email"
              disabled
              v-validate="'required|email'"
              name="email"
              v-model="email"
            />
            <span class="text-danger text-sm">{{ errors.first('profile.email') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="First Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="firstname"
              v-model="firstName"
            />
            <span class="text-danger text-sm">{{ errors.first('profile.firstname') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="Last Name"
              v-validate="'required|alpha_spaces|max:25'"
              name="lastname"
              v-model="lastName"
            />
            <span class="text-danger text-sm">{{ errors.first('profile.lastname') }}</span>
          </div>
        </div>

        <!-- <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <label>Profile Image</label>
          <input
            type="file"
            class="w-full vs-inputx vs-input--input normal hasValue"
            label="Profile Image"
            name="profile-image"
            accept="image/*"
            @change="onFileChanged"
          />
          <span class="text-danger text-sm">{{ errors.first('profile-image') }}</span>
        </div>
        </div>-->
        <div class="vx-row mb-2" v-if="$store.state.uInfo.role !='SA'">
          <div class="vx-col form-group w-1/3">
            <vs-input
              class="w-full"
              label="Mobile/Cell"
              v-validate="'numeric|min:10|max:10'"
              name="phone"
              v-model="phone"
              autocomplete="off"
              type="number"
              @keydown="filterKey"
            />
            <span class="text-danger text-sm">{{ errors.first('profile.phone') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="User Id"
              v-validate="'alphaNumSchar|max:5'"
              name="user_id"
              v-model="user_id"
            />
            <span class="text-danger text-sm">{{ errors.first('profile.user_id') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full">
            <vs-input
              class="w-full"
              label="Job Title"
              v-validate="'alpha_spaces|max:25'"
              name="designation"
              v-model="designation"
              autocomplete="off"
              disabled
            />
            <span class="text-danger text-sm">{{ errors.first('profile.designation') }}</span>
          </div>
        </div>
        <div
          class="vx-row mb-2"
          v-if="$store.state.uInfo.role !='CA' && $store.state.uInfo.role !='SA'"
        >
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="User Role"
              name="role"
              v-model="role"
              autocomplete="off"
              disabled
            />
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="Office Name"
              name="Office"
              v-model="office"
              autocomplete="off"
              disabled
            />
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              label="Department Name"
              name="Department"
              v-model="department"
              autocomplete="off"
              disabled
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col md:w-1/2">
            <label>Profile</label>
            <div class v-if="!profile_image">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                name="profile_image"
                :width="100"
                :height="100"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                color="primary"
                @click.prevent="show_image_popup = !show_image_popup"
                id="upload-profile-button"
              >Upload Profile</vs-button>
              <span class="text-danger text-sm">{{ errors.first('profile_image') }}</span>
            </div>
            <div class="vx-col md:w-1/2" v-else>
              <div class="img-upload" v-if="profile_image">
                <img
                  :src="profile_image"
                  class="mr-1"
                  style="width: 100px; max-height: 100px; float:left;"
                />
                <vs-button
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeProfile()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col w-full">
            <vs-button
              class="mt-4 shadow-lg m-auto"
              type="gradient"
              color="#39b54a"
              gradient-color-secondary="#4cd964"
              @click.prevent="update()"
              id="user-profile"
              :disabled="button_loading"
            >Save</vs-button>
            <vs-button class="mt-4 ml-4 m-auto" color="warning" @click="cancel()">Cancel</vs-button>
          </div>
        </div>
      </form>
    </vx-card>
    <vx-card class="mt-5" title="Change Password">
      <form data-vv-scope="change_password" @submit.prevent>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              type="password"
              label="Old Password"
              v-validate="'required'"
              name="old_password"
              v-model="old_password"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('change_password.old_password') }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              ref="password"
              type="password"
              label="New Password"
              v-validate="'required|verify_password|min:8|max:20'"
              name="password"
              v-model="new_password"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('change_password.password') }}</span>
          </div>

          <div class="vx-col w-1/3">
            <vs-input
              class="w-full"
              type="password"
              label="Confirm New Password"
              @keyup.enter.native="change_password()"
              v-validate="'required|confirmed:password'"
              name="password_confirmation"
              v-model="confirm_password"
              autocomplete="off"
            />
            <span
              class="text-danger text-sm"
            >{{ errors.first('change_password.password_confirmation') }}</span>
          </div>

          <!--   <div class="vx-row mt-6"> -->
          <div class="vx-col w-full">
            <vs-button
              class="mt-4 shadow-lg m-auto"
              type="gradient"
              color="#39b54a"
              gradient-color-secondary="#4cd964"
              @click.prevent="change_password()"
              :disabled="button_loading"
              id="reset-password"
            >Save</vs-button>
            <vs-button class="mt-4 ml-4 m-auto" color="warning" @click.prevent="cancel()">Cancel</vs-button>
          </div>
          <!-- </div> -->
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import VueImageUpload from "vue-image-crop-upload";

Validator.extend("verify_password", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});
Validator.extend("alphaNumSchar", {
  //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp('^[a-zA-Z0-9!@#$%^*&()\\-`.+,/"]*$');
    return strongRegex.test(value);
  }
});

const dict = {
  custom: {
    firstname: {
      required: "Please enter first name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "First name should not be greater than 25 characters"
    },
    user_id: {
      alpha_num: "Only alphabetic characters and numbers allowed",
      max: "User Id should not be greater than 5 characters",
      alphaNumSchar: "Only alphanumeric and special characters allowed"
    },
    lastname: {
      required: "Please enter last name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Last name should not be greater than 25 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    phone: {
      required: "Please enter phone number",
      numeric: "Please enter valid number",
      min: "Phone number must be at least 10 digits",
      max: "Phone number may not be greater than 10 digits"
    },
    designation: {
      required: "Please enter user job title",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Designation should not be greater than 25 characters"
    },
    old_password: {
      required: "Old password is required"
    },
    password: {
      required: "New password is required",
      min: "Password should be minimum 8 characters",
      verify_password:
        "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Confirm password is required",
      confirmed: "Confirm password and New password should be same"
    }
  }
};
// register custom messages
Validator.localize("en", dict);
export default {
  components: {
    "vue-image-upload": VueImageUpload
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      id: null,
      role: null,
      profileImage: null,
      phone: null,
      designation: null,
      user_id: "",
      office: null,
      department: null,
      old_password: null,
      new_password: null,
      confirm_password: null,
      roles: null,
      profile_image: null,
      show_image_popup: false,
      profile_image_update: false
    };
  },
  mounted() {
    if (this.$store.state.uInfo) {
      let user = this.$store.state.uInfo;
      this.email = user.email;
      this.firstName = user.firstname;
      this.phone = user.phone;
      this.lastName = user.lastname;
      this.id = user.id;
      this.profile_image = user.profile_image;
      (this.roles = user.role),
        (this.role =
          user.role == "U"
            ? "User"
            : user.role == "CA"
            ? "Company Admin"
            : user.role == "HR"
            ? "HR"
            : "Super Admin");
      this.designation = user.designation;
      this.office = user.office_nm;
      this.department = user.department_nm;
      this.user_id = user.user_id == undefined ? "" : user.user_id;
    }
  },
  methods: {
    removeProfile() {
      this.profile_image = "";
      this.profile_image_update = true;
    },
    cropSuccess(imgDataUrl, field) {
      this.profile_image = imgDataUrl;
      this.profile_image_update = true;
      // if(this.$route.params.id) {
      //     this.imageUpdate = true
      // }
    },
    onFileChanged(event) {
      this.profileImage = event.target.files[0];
    },
    update() {
      this.$validator.validateAll("profile").then(result => {
        if (result) {
          // let input = {
          //   firstname: this.firstName,
          //   lastname: this.lastName
          // };
          let formData = new FormData();
          formData.append("file", this.profileImage);
          formData.append("firstname", this.firstName);
          formData.append("lastname", this.lastName);
          formData.append("designation", this.designation);
          formData.append("user_id", this.user_id);
          formData.append("phone", this.phone);
          formData.append("profile_image", this.profile_image);
          formData.append("profile_image_update", this.profile_image_update);
          this.button_loader(true, "#user-profile");

          this.axios
            .post("auth/editProfile", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              // console.log(response);
              let data = response.data.data;
              let userStoreInfo = this.$store.state.uInfo;

              this.button_loader(false, "#user-profile");
              userStoreInfo.firstname = data.firstname;
              userStoreInfo.lastname = data.lastname;
              userStoreInfo.phone = data.phone;
              userStoreInfo.designation = data.designation;
              userStoreInfo.user_id = data.user_id;
              userStoreInfo.profile_image = data.profile_image;
              localStorage.setItem("user", JSON.stringify(userStoreInfo));

              this.$store.dispatch("updateUser", userStoreInfo);

              let text = "Profile updated successfully!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });

              /*  if (data.roles === "SA") {
                this.$router.push({ name: "adminDashboard" });
              }
              if (data.roles === "CA" || data.roles === "HR") {
                this.$router.push({ name: "organizationDashboard" });
              } */
              this.cancel();
            })
            .catch(e => {
              this.showError(e, "#user-profile");
            });
        }
      });
    },
    cancel() {
      history.back();
    },
    change_password() {
      this.$validator.validateAll("change_password").then(result => {
        if (result) {
          this.button_loader(true, "#reset-password");
          let input = {
            oldPassword: this.old_password,
            newPassword: this.new_password
          };
          this.axios
            .post("auth/resetPassword", input)
            .then(response => {
              this.button_loader(false, "#reset-password");
              let text = "Password updated successfully!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });

              this.cancel();
            })
            .catch(e => {
              this.showError(e, "#reset-password");
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.img-upload img {
  border-radius: 50%;
  object-fit: cover;
}
</style>
